import { render, staticRenderFns } from "./PhotoEditorModal.vue?vue&type=template&id=1fbbedb9&scoped=true"
import script from "./PhotoEditorModal.vue?vue&type=script&lang=js"
export * from "./PhotoEditorModal.vue?vue&type=script&lang=js"
import style0 from "./PhotoEditorModal.vue?vue&type=style&index=0&id=1fbbedb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbbedb9",
  null
  
)

export default component.exports